import React, { ReactNode } from 'react';
import TaxCalendar from '../calendar/tax-calendar';
import BlockGovServiceList from '/react4xp/parts/block-gov-service-list/block-gov-service-list';
import BlockQrLinks from '/react4xp/parts/block-qr-links/block-qr-links';
import BlockServiceList from '/react4xp/parts/block-service-list/block-service-list';
import ChairmanBlog from '/react4xp/parts/chairman-blog/chairman-blog';
import ExpressServicesBlock from '/react4xp/parts/express-services-block/express-services-block';
import ExternalResources from '/react4xp/parts/external-resources/external-resources';
import QuestionsBlock from '/react4xp/parts/questions-block/questions-block';
import QuestionsBlockAnswers from '/react4xp/parts/questions-block-answers/questions-block-answers';
import Search from '/react4xp/parts/search/search';
import ServiceBlockWithButton from '/react4xp/parts/service-block-with-button/service-block-with-button';
import ServiceLinkImg from '/react4xp/parts/service-link-img/service-link-img';
import PressCenter from '/react4xp/parts/press-center/press-center';
import ElectionRuImg from '../../../assets/images/election.png';

export type MainBlock = {
    node: ReactNode;
    id: string;
    defaultWeight?: number;
};

const getBlock = (item: any, props: any) => {
    return (
        <ServiceBlockWithButton
            {...props}
            config={{
                ...item,
                image: item.backgroundImage,
            }}
        />
    );
};

export const getMainBlocks = (props: any, translations: any): MainBlock[] => {
    const arr: MainBlock[] = [];

    if (translations) {
        arr.push({
            node: (
                <BlockGovServiceList
                    {...props}
                    pageName={props.config.govServiceTitle}
                    image={props.config.govServiceIcon}
                />
            ),
            id: 'govService',
        });

        arr.push({
            node: (
                <BlockServiceList
                    {...props}
                    pageName={props.config.serviceTitle}
                    image={props.config.serviceIcon}
                />
            ),
            id: 'service',
        });

        arr.push({
            node: (
                <ServiceLinkImg
                    {...props}
                    name={props.config.serviceLink1Name}
                    img={props.config.serviceLink1Img}
                    url={`/${props.language}${props.config.serviceLink1Url}`}
                />
            ),
            id: 'serviceLink1',
        });

        arr.push({
            node: (
                <ServiceLinkImg
                    {...props}
                    name={props.config.serviceLink2Name}
                    img={props.config.serviceLink2Img}
                    url={'https://drive.google.com/drive/mobile/folders/1gpCeL6HzRoTuQX3GhwMZShgXZYRGjdHt?usp=sharing'}
                />
            ),
            id: 'serviceLink2',
        });

        arr.push({
            node: (
                <ServiceLinkImg
                    {...props}
                    name={props.config.serviceLink3Name}
                    img={props.config.serviceLink3Img}
                    url={`/${props.language}${props.config.serviceLink3Url}`}
                />
            ),
            id: 'serviceLink3',
        });

        arr.push({
            node: (
                <QuestionsBlock
                    {...props}
                    translations={translations}
                />
            ),
            id: 'serviceLink4',
        });

        arr.push({
            node: (
                <Search
                    {...props}
                    title={props.config.searchTitle}
                    url={props.config.searchUrl}
                    name={props.config.searchName}
                    translations={translations}
                />
            ),
            id: 'search',
        });

        arr.push({
            node: (
                <ExpressServicesBlock
                    {...props}
                    config={{
                        urlList: props.config.expUrlList,
                        url1: props.config.expUrl1,
                        url2: props.config.expUrl2,
                        url3: props.config.expUrl3,
                        url4: props.config.expUrl4,
                    }}
                    language={props.language}
                    translations={translations}
                />
            ),
            id: 'exp',
        });

        arr.push({
            node: (
                <ChairmanBlog
                    {...props}
                    config={{
                        nameBlog: props.config.chairmanNameBlog,
                        name: props.config.chairmanName,
                        image: props.config.chairmanImage,
                        link: props.config.chairmanLink,
                        questionText: props.config.chairmanQuestionText,
                    }}
                />
            ),
            id: 'chairman',
        });

        arr.push({
            node: (
                <TaxCalendar
                    {...props}
                    translations={translations}
                />
            ),
            id: 'calendar',
        });

        if (props.config.sb) {
            arr.push({
                node: (
                    <div className="two-nested-columns">
                        <div className="xp-region">{getBlock(props.config.sb[1], props)}</div>
                        <div className="xp-region">{getBlock(props.config.sb[0], props)}</div>
                    </div>
                ),
                id: 'sb',
            });
        }

        arr.push({
            node: (
                <QuestionsBlockAnswers
                    {...props}
                    translations={translations}
                />
            ),
            id: 'questionsAnswers',
        });

        arr.push({
            node: (
                <ServiceLinkImg
                    {...props}
                    img={props.config.electionLinkImg}
                    imgSrc={ElectionRuImg}
                    url={
                        props.language === 'kk' || props.language === 'kz'
                            ? 'https://www.election.gov.kz/kaz/banners/?ID=10194'
                            : 'https://www.election.gov.kz/rus/banners/?ID=10194'
                    }
                    isBlank
                />
            ),
            id: 'electionLink',
            defaultWeight: 15,
        });

        arr.push({
            node: (
                <ServiceLinkImg
                    {...props}
                    name={props.config.constitutionLinkName || 'Конституция Республики Казахстан'}
                    maxWidth={props.config.constitutionLinkMaxWidth || 302}
                    img={props.config.constitutionLinkImg}
                    imgSrc={props.constitutionLinkImgUrl}
                    url={
                        props.config.constitutionLinkUrl ||
                        'https://adilet.zan.kz/rus/docs/K2600000000'
                    }
                    isBlank
                    className="service-link-img--contrast-text"
                />
            ),
            id: 'constitutionLink',
            defaultWeight: 14,
        });

        arr.push({
            node: (
                <PressCenter
                    {...props}
                    translations={translations}
                />
            ),
            id: 'pressCenter',
        });

        if (props.config.qr) {
            arr.push({
                node: (
                    <BlockQrLinks
                        links={props.config.qr}
                        translations={translations}
                    />
                ),
                id: 'qr',
            });
        }

        arr.push({
            node: (
                <ExternalResources
                    {...props}
                    config={{
                        title: props.config.erTitle,
                        size: props.config.erSize,
                        expand: props.config.erExpand,
                        name: props.config.erName,
                    }}
                />
            ),
            id: 'er',
        });
    }

    return arr;
};
